import { AdminInquiryConst } from "../Constants/AdminInquiryConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

const buildHeaders = () => {
  const token = localStorage.getItem("accessToken");
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  return headers;
};

export const FetchAllAdminInquiries = (status) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.FETCH_ALL_REQUEST });

    const qs = status ? `?status=${status}` : "";

    fetch(`${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRIES}${qs}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AdminInquiryConst.FETCH_ALL_SUCCESS, result });
        } else {
          dispatch({ type: AdminInquiryConst.FETCH_ALL_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AdminInquiryConst.FETCH_ALL_FAIL,
          result: { statusCode: 500, message: error.message },
        });
      });
  };
};

export const FetchAdminInquiryMessages = (inquiryId) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRY_MESSAGES(inquiryId)}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_SUCCESS, result });
        } else {
          dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AdminInquiryConst.FETCH_MESSAGES_FAIL,
          result: { statusCode: 500, message: error.message },
        });
      });
  };
};

export const SendAdminInquiryMessage = (inquiryId, message) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.SEND_MESSAGE_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRY_MESSAGES(inquiryId)}`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ message }),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200 || result.statusCode === 201) {
          dispatch({ type: AdminInquiryConst.SEND_MESSAGE_SUCCESS, result });
        } else {
          dispatch({ type: AdminInquiryConst.SEND_MESSAGE_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AdminInquiryConst.SEND_MESSAGE_FAIL,
          result: { statusCode: 500, message: error.message },
        });
      });
  };
};

export const UpdateAdminInquiryStatus = (inquiryId, status) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.UPDATE_STATUS_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRY_STATUS(inquiryId)}`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify({ status }),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AdminInquiryConst.UPDATE_STATUS_SUCCESS, result });
        } else {
          dispatch({ type: AdminInquiryConst.UPDATE_STATUS_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AdminInquiryConst.UPDATE_STATUS_FAIL,
          result: { statusCode: 500, message: error.message },
        });
      });
  };
};

export const ClearAdminInquiryAction = () => ({ type: AdminInquiryConst.CLEAR_ACTION });
